import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENGAGEMENT_SIGN_FORM_MOBILE_OPT_IN_CONFIG = createFcmDetails(
	'engagement_sign_form_mobile_opt_in_config',
	{
		owner: 'supporters pack',
		context: 'petition page',
		import: false,
		description: `List of country codes for which the mobile opt-in checkbox should be available.
			That checkbox then allows to enter a mobile phone number to receive updates and recommendations via text or Whatsapp.
			Related experiment: engagement_sign_form_mobile_opt_in
		`,
		template: ['US', 'CA'],
	},
);
